import React from "react";

const paraStyle = {
  textAlign: "justify",
  textJustify: "inter-word"
};

export default () => (
  <div className="pa3 pt5 w-60-l center pb6" style={{ minHeight: 400 }}>
    <h1 className="tc">How to Apply</h1>
    <h2 className="fw6 f4 mt4 mb3">Disclaimer</h2>
    <p style={paraStyle}>
      Application for all vacancies is free. Under no circumstance will you be
      required to pay any sum of money or disclose your account information to
      any person. The only platform for registration is through
      dsaportal.gov.ng. DSA will not be held responsible for any information
      provided to other websites.
    </p>
    <h2 className="fw6 f4 mt4 mb3">Application procedure</h2>
    <ol className="pl4 mt3 f5" style={{ lineHeight: "2.3rem", ...paraStyle }}>
      <li className="pl3">
        To begin, carefully read the instructions on the application guidelines
        before you begin your registration{" "}
      </li>
      <li className="pl3">
        Click the register button on the top right corner of this page to
        register.{" "}
      </li>
      <li className="pl3">
        To complete the registration, make sure you fill the registration form.
      </li>
      <li className="pl3">
        After registration, you will be required to activate your account by
        clicking on the link sent to your email
      </li>
      <li className="pl3">Login with your email and password.</li>
      <li className="pl3">
        Carefully read the job descripion and requirements then click the apply
        button for your preffered position.
      </li>
      <li className="pl3">
        Provide correct information for all fields, upload your passport
        photograph and CV then click the submit button.
      </li>
      <li className="pl3 mt2">
        An email would be sent to you confirming the success of your submission.
      </li>
      <li className="pl3">
        Any developments in respect to your application would be communicated to
        you.
      </li>
    </ol>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/howItWorks.js